import { mockComponent } from 'bloko/common/setupMockComponents';

const { InputType, InputScale } = jest.requireActual('bloko/blocks/inputText/index.js');
export { InputType, InputScale };

export default mockComponent('InputText');
